import {createReducer} from '@reduxjs/toolkit'
import {navigate} from '../actions/navigation'
import {placeOrder, updateOrder} from '../actions/placed-order'
import {addTicketsToCart, initiateEcomCheckoutFlow, makeReservation} from '../actions/reservation'
import {sendRsvp} from '../actions/rsvp'
import {PendingRequests} from '../types/state'

const initialState: PendingRequests = {
  loading: {},
}

const SUPPORTED_ACTIONS = [
  makeReservation,
  navigate,
  placeOrder,
  updateOrder,
  sendRsvp,
  initiateEcomCheckoutFlow,
  addTicketsToCart,
]

export const pendingRequests = createReducer(initialState, builder => {
  SUPPORTED_ACTIONS.forEach(action =>
    builder
      .addCase(action.pending, state => {
        state.loading[action.typePrefix] = true
      })
      .addCase(action.fulfilled, state => {
        state.loading[action.typePrefix] = false
      })
      .addCase(action.rejected, state => {
        state.loading[action.typePrefix] = false
      }),
  )
})
